/** The routes the Growth Score page links between. */
export const CHAT_PATH = '/onboarding'
export const ASSESSMENT_PATH = '/onboarding/assessment'
